import React from "react";
import {ItemImageType} from "./ItemImageType";
import AvailableSizes from './ItemImageSizes';
import './ItemImage.sass';
import './ItemImageGenerated.sass';

type Props = {
    item: string,
}

export default function ItemImage({ item }: Props) {
    const itemType = item.replace(/[ \-]/g, '') as ItemImageType;
    const sizes = AvailableSizes[itemType];
    if (!sizes) {
        console.log(`Warning: Invalid item for <ItemImage />: ${item} -> ${itemType}`);
        return <i className='satisfactoryItemImage'></i>
    }
    const size = (sizes.includes(256) ? 256 : sizes[0]);
    return <i className={`satisfactoryItemImage itemType_${itemType}_${size}`}></i>
}
